export interface IAccuracyClaimResponse {
  original_claim: string;
  normalized_claim: string;
  applied_fact: string;
}

/** Parsed `contentDetails` of an ACCURACY_CLAIM_VERIFICATION analysis. */
export interface IAccuracyAnalysisResponse {
  inaccurate: IAccuracyClaimResponse[] | null;
}

export interface IAccuracyClaim {
  originalClaim: string;
  normalizedClaim: string;
  appliedFact: string;
}

export enum AccuracyFeedbackState {
  Loading = 'LOADING',
  Flagged = 'FLAGGED',
  Clear = 'CLEAR',
  Error = 'ERROR',
}

/** The resolved accuracy state and the claims that belong to it. */
export interface IAccuracyFeedback {
  state: AccuracyFeedbackState;
  claims: IAccuracyClaim[];
}
